import { t } from '@/shared/lib/i18n'
import { showsFailedNeedsRerunRibbon } from '@/shared/lib/showsFailedNeedsRerunRibbon'

export interface TaskLogStatusSource {
  isNpt: boolean
  qcPassed: boolean | null
  dateModified: boolean
}

export interface TaskLogStatusDisplay {
  label: string
  className: string
}

/**
 * Canonical task-log Complete / Failure / NPT status pill (Log Details, Occurrences,
 * Task Change Log). Date-modified QC-passed completes use amber "Complete (Date Modified)".
 */
export const getTaskLogStatusDisplay = (log: TaskLogStatusSource): TaskLogStatusDisplay => {
  const isFailure = showsFailedNeedsRerunRibbon(log.qcPassed, log.isNpt)

  if (log.isNpt) {
    return log.dateModified === true
      ? {
          label: t('instruments.reports.logDetails.nptDateModified'),
          className: 'bg-amber-100 text-amber-800 border-amber-200',
        }
      : {
          label: t('instruments.reports.logDetails.npt'),
          className: 'bg-gray-100 text-gray-700 border-gray-200',
        }
  }
  if (isFailure) {
    return {
      label: t('instruments.reports.logDetails.failure'),
      className: 'bg-red-100 text-red-700 border-red-200',
    }
  }
  if (log.dateModified === true) {
    return {
      label: t('instruments.reports.logDetails.completeDateModified'),
      className: 'bg-amber-100 text-amber-800 border-amber-200',
    }
  }
  return {
    label: t('instruments.reports.logDetails.complete'),
    className: 'bg-green-100 text-green-700 border-green-200',
  }
}
